import { useQuery } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';

import { GET_BOOK } from './queries';

import View from './View';
import CollaborationPage from '../../containers/CollaborationPage';
import { useSelector } from 'react-redux';

const Book = () => {
  const [sp] = useSearchParams();
  const i = sp.get('i');
  const id = i ? parseInt(i, 10) : null;

  const { data, loading, error, refetch } = useQuery(GET_BOOK, {
    variables: {
      id,
    },
  });

  const isLoggedIn = useSelector((state) => state.auth.cognitoUser);

  return (
    <CollaborationPage
      className="pt-1 pb-5"
      loading={loading}
      error={error}
      onRetry={refetch}
    >
      <View data={data?.getBook} isLoggedIn={isLoggedIn} />
    </CollaborationPage>
  );
};

export default Book;
